import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminBusinessActivities = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITIES.GET_ALL, { params });
    return response.data;
};

export const getAdminBusinessActivityById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITIES.GET_BY_ID(id));
    return response.data;
};

export const createBusinessActivity = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITIES.CREATE, data);
    return response.data;
};

export const updateBusinessActivity = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITIES.UPDATE(id), data);
    return response.data;
};

export const deleteBusinessActivity = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITIES.DELETE(id));
    return response.data;
};
